import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

export default class BaseSidebar extends View {

	get template() {
		return template;
	}

	get className() {
		let type_sidebar = this.getOption( 'type_sidebar' ) || '';
		return `page-layout ${type_sidebar}`;
	}

	regions() {
		return {
			top_content:   '.top-content',
			content:       '.content',
			sidebar:       '.sidebar',
			ads_container: '.ads-container',
			widget:        '.widget-container'
		};
	}

}